export default __webpack_public_path__ + "static/media/campus.17436548.jpg";